import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

/* SAMPLE DATA */
import { areaData } from "../../../data/graphs";

const NetProfitLossGraph = () => {
  const [state] = useState({
    series: [
      {
        name: "Cumulative Net P&L",
        data: areaData,
      },
    ],
    options: {
      chart: {
        id: "area-datetime",
        type: "area",
        fontFamily: "ProximaNova-Semibold",
        zoom: {
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },
      xaxis: {
        type: "datetime",
        min: new Date("01 Mar 2012").getTime(),
        tickAmount: 6,
        labels: {
          show: false,
        },
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      stroke: {
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: ["#4CAF50"],
    },
  });

  return (
    <div className="area-chart -my-8 -ml-5 -mr-1">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="area"
      />
    </div>
  );
};

const NetProfitLossGraphDark = () => {
  const [state] = useState({
    series: [
      {
        name: "Cumulative Net P&L",
        data: areaData,
      },
    ],
    options: {
      chart: {
        id: "area-datetime",
        type: "area",
        fontFamily: "ProximaNova-Semibold",
        zoom: {
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },
      xaxis: {
        type: "datetime",
        min: new Date("01 Mar 2012").getTime(),
        tickAmount: 6,
        labels: {
          show: false,
        },
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      stroke: {
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: ["#4CAF50"],
    },
  });

  return (
    <div className="area-chart -my-8 -ml-5 -mr-1">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="area"
      />
    </div>
  );
};

export { NetProfitLossGraph, NetProfitLossGraphDark };
